import {
  FETCH_JOB_LIST,
  FETCH_JOB_LIST_SUCCESS,
  FETCH_JOB_LIST_FAILURE,
  RELOAD_JOB_LIST,
  RESET_JOB_ITEMS,
  SET_JOB_PAGE_INDEX,
  SET_JOB_PAGE_SIZE,
} from '../../action/Build';

const initialState = {
  isLoading: NaN,
  error: '',
  items: [],
  pageIndex: 0,
  pageSize: 20,
  totalCount: 0,
  requestId: '',
};
const BuildListReducer = (curState = initialState, action = { type: '', payload: '' }) => {
  let newState;
  switch (action.type) {
    case FETCH_JOB_LIST:
      newState = {
        ...curState,
        error: null,
        isLoading: true,
        ...action.payload,
      };
      break;
    case FETCH_JOB_LIST_SUCCESS: {
      const {
        resultArr, totalCount, requestId,
      } = action.payload;
      if (requestId === curState.requestId) {
        newState = {
          ...curState,
          totalCount,
          isLoading: false,
          items: curState.items.concat(resultArr),
        };
      } else {
        newState = curState;
      }

      break;
    }
    case FETCH_JOB_LIST_FAILURE:
      newState = {
        ...curState, isLoading: false, skip: 0, error: action.payload, requestId: '',
      };
      break;
    case SET_JOB_PAGE_SIZE: {
      newState = {
        ...initialState,
        isLoading: curState.isLoading,
        pageSize: action.payload,
      };
      break;
    }
    case SET_JOB_PAGE_INDEX: {
      newState = {
        ...curState,
        pageIndex: action.payload,
      };
      break;
    }
    case RESET_JOB_ITEMS: {
      newState = { ...initialState };
      break;
    }
    case RELOAD_JOB_LIST: {
      const { pageSize } = curState;
      newState = { ...initialState, pageIndex: 0, pageSize };
      break;
    }
    default:
      newState = curState;
  }

  return newState;
};

export default BuildListReducer;
